import BulletSvg from '@/assets/icons/bullet.svg?component';

export default {
  name: 'IconBullet',
  components: { BulletSvg },
  props: {
    color: { type: String, default: 'rgb(0,0,0)' },
    size:  { type: String, default: '1em' }, // поддерживает 'px', 'em', 'rem'
    tooltipEnabled: { type: Boolean, default: true },
  },
  computed: {
    svgStyle() {
      return {
        width: this.size,
        height: this.size,
        color: this.color,       // внутри svg должно быть fill="currentColor"
      };
    },
    tooltipOptions() {
      return {
        value: this.$t('controls.bullet'),
        class: 'tt-sm',
        disabled: !this.tooltipEnabled,
      };
    },
  },
};
